import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBadges from "@/components/TrustBadges";
import FeaturedTestimonial from "@/components/FeaturedTestimonial";
import ServicesSection from "@/components/ServicesSection";
import StainSelectionSection from "@/components/StainSelectionSection";
import TrustSection from "@/components/TrustSection";
import WhatToExpect from "@/components/WhatToExpect";
import FlooringTipsSection from "@/components/FlooringTipsSection";
import VideoSection from "@/components/VideoSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import StickyMobileCall from "@/components/StickyMobileCall";

const Index = () => {
  return (
    <div className="min-h-screen pb-16 lg:pb-0">
      <Header />
      <main>
        <Hero />
        <TrustBadges />
        <FeaturedTestimonial />
        <ServicesSection />
        <StainSelectionSection />
        <TrustSection />
        <WhatToExpect />
        <FlooringTipsSection />
        <VideoSection />
        <CTASection />
      </main>
      <Footer />
      <StickyMobileCall />
    </div>
  );
};

export default Index;
